import initialState from '../initial-state';
import * as types from '../actions/action-types';

export function notificationsReducer(state = initialState.notifications, action) {
	switch (action.type) {
		case types.ADD_NOTIFICATION:
			return [action.notification];
		case types.DELETE_NOTIFICATION:
			return state.filter(item => item.message !== action.notification.message)
		default:
			return state;
	}
}
